import { fetchGet } from './api';
import { ISchoolLevel } from '../types/school-level.type';

export const fetchSchoolLevels = () => fetchGet<ISchoolLevel[]>('school-levels');
